/** The $STRIKE lockup: a coin cut by a call payoff, and the wordmark. */
export function Logo({ size = 28 }: { size?: number }) {
  return (
    <span className="brand">
      <img src="/mark.svg" alt="" width={size} height={size} />
      <span className="brand-word">STRIKE</span>
    </span>
  );
}
